import {
	CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS, PAGE_SHIFT_SOLICITOR_ARTICLES,
	RECEIVE_BAD_RESPONSE_GET_ALL_ARTICLES_SUGGESTIONS, RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS,
	REQUEST_GET_ALL_ARTICLES_SUGGESTIONS
} from "./index";

//action that changes the store settings
export function changeSolicitorArticlesListSettings(key, value){
	return {
		type: CHANGE_SOLICITOR_ARTICLES_LIST_SETTINGS,
		payload: {
			key,
			value
		}
	}
}

//action that shifts the page value +-1
export function pageShiftSolicitorArticles(direction, totalPaginationBoxes){
	return {
		type: PAGE_SHIFT_SOLICITOR_ARTICLES,
		payload: {
			direction: direction,
			totalPaginationBoxes: totalPaginationBoxes
		}
	}
}


export function requestGetAllArticlesSuggestions(payload) {
	return {
		type: REQUEST_GET_ALL_ARTICLES_SUGGESTIONS,
		payload
	}
}

//action that receives all the applications from the api
export function receiveGetAllArticlesSuggestions(payload) {
	return {
		type: RECEIVE_GET_ALL_ARTICLES_SUGGESTIONS ,
		payload
	}
}

//action that receives bad response fetching all the applications from the api
export function receiveBadResponseGetAllArticlesSuggestions(payload) {
	return {
		type: RECEIVE_BAD_RESPONSE_GET_ALL_ARTICLES_SUGGESTIONS ,
		payload
	}
}